import React, { useState } from "react";
import { Navbar, Nav, Container,  } from "react-bootstrap"; // Import necessary components from React Bootstrap
import logo from "../../assets/DPBA_2Logo-Canada-1024x297.png"; // Import the logo image from assets folder
import styles from './NavbarLogo.module.css'; // Import the corresponding CSS module for styling
import { NavLink, useNavigate } from "react-router-dom";
import SignUp from "../../Pages/Auth/SignUp";
import Login from "../../Pages/Auth/Login";

const NavbarLogo = () => {
  let navigate = useNavigate();
  const [dialog,setDialog] = useState(false);
  const [loginDialog,setLoginDialog] = useState(false);
  return (
    <>
      <Navbar bg="white"  expand="lg" className={styles.customNavbar}>
        <Container  fluid>
          {/* Logo */}
          <Navbar.Brand href="/" className={styles.logoContainer}>
            <img src={logo} alt="Logo" className={styles.logo} />
          </Navbar.Brand>

          {/* Navbar Links */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="">
            <Nav className="main_container_navlink  w-75 "> 
              <NavLink  to="/" className={({ isActive }) => isActive ? styles.activeLink : " NavLink_style "}>Home</NavLink >
              <NavLink  to="/jobPortal" className={({ isActive }) => isActive ? styles.activeLink : " NavLink_style "}>Jobs</NavLink >
              <NavLink  to="/aboutUs" className={({ isActive }) => isActive ? styles.activeLink : " NavLink_style "}>About</NavLink >
              <NavLink  to="/programme" className={({ isActive }) => isActive ? styles.activeLink : "NavLink_style "}>Programme</NavLink >
              <NavLink  to="/contactUs"  className={({ isActive }) => isActive ? styles.activeLink : "NavLink_style"}>Contact</NavLink>
            </Nav>
            <div className="d-flex  gap-3  w-25 ">
              <button className="btn btn-primary" onClick={()=>{setLoginDialog(true)}}>Sign In</button>
              <button className="btn border border-primary text-primary" onClick={()=>{setDialog(true)}}>Sign Up</button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <SignUp dialog={dialog} setDialog={setDialog}/>
      <Login loginDialog={loginDialog} setLoginDialog={setLoginDialog} />
    </>
  );
};

export default NavbarLogo;
